import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import tw, { styled } from "twin.macro"
import { keyBy } from "lodash"

import ProductGroupCard from "components/product-group-card"

const Styles = styled.div`
  ${tw`w-full flex flex-col items-center justify-center l:grid l:grid-cols-3
       gap-y-5 gap-x-4 mx-auto max-w-s m:max-w-m l:max-w-l`}
`

const ProductCards = ({ cardKeys }) => {
  const query = graphql`
    query ProductCards {
      gcms {
        contentBlocks(
          where: { identifier_starts_with: "product-group-card-" }
        ) {
          id
          identifier
          title
          linkUrl
          featuredImage {
            url
          }
          icon {
            url
          }
          mainContent {
            html
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const { contentBlocks } = data.gcms

  const allCards = keyBy(contentBlocks, ({ identifier }) =>
    identifier.replace("product-group-card-", "")
  )

  if (!cardKeys?.length) return null

  const cards = cardKeys
    .reduce((prevCards, cardId) => {
      const className = cardId.includes("demand360") ? "purple-bullet" : ""

      const cards = [
        {
          key: cardId,
          info: allCards[cardId],
          className,
        },
      ]

      if (cardId.endsWith("-maxi-card")) {
        cards[0].className += " maxi-card"

        const addedCardId = cardId.replace("-maxi-card", "")

        cards.push({
          key: addedCardId,
          info: allCards[addedCardId],
          className: className + " mobile-only",
        })
      }

      return prevCards.concat(cards)
    }, [])
    .filter((card) => card.info)

  return (
    <Styles>
      {cards.map((card) => (
        <ProductGroupCard
          key={card.key}
          cardInfo={card.info}
          className={card.className}
        />
      ))}
    </Styles>
  )
}

export default ProductCards
